import React, { Component } from 'react'
import PropTypes from 'prop-types'
import UrlBuilder from '../shared/urlBuilder/UrlBuilder'
import IconExpired from '../../globals/images/icon_expired.svg'
import ReactDOM from 'react-dom'

export default class ChangePasswordTokenExpired extends Component  {

    get config() {
        return this.props.config || {}
    }
    get forgotPasswordUrl() {
        return this.props.config.forgotPasswordUrl || process.env.REACT_APP_FORGOT_PASSWORD
    }
    componentDidMount() {
        ReactDOM.findDOMNode( this.refs.expiredLinkCard ).focus() 
    }
    render() {
        const title = 'Password Link Expired'
        const message ='The reset password link has expired. Need a new link?'
        const ariaMessage = title +'. '+ message + ' Request again.'
        return (
            <>
                <main className="c-main">
                    <div className="os-container--max-width">
                        <div className="c-form-card"  ref={ 'expiredLinkCard' } aria-label={ ariaMessage } tabIndex={ 0 }>
                            <div className="c-form-card__container">
                                <h1 className="o-heading-alpha mb-8 pb-0 pl-9 heading-token-expired" tabIndex={ 0 } autoFocus={ true }>
                                    <img src={ IconExpired } alt="Token Expired" className="c-svg-header-icon"/>
                                    { title } 
                                </h1>
                                <div className="c-form-link-expired"><p data-testid="main-message" tabIndex={ 0 }>{ message }<a href={ UrlBuilder( { url: this.forgotPasswordUrl, buildURL: true } ) } className="c-link"><span className="link-expired-option">Request again</span></a></p></div>
                            </div>
                        </div>
                    </div>
                </main>
            </>
        )
    }
}

ChangePasswordTokenExpired.propTypes = {
    config: PropTypes.shape( {
        forgotPasswordUrl: PropTypes.string
    } )
}